import { render, staticRenderFns } from "./Stop.vue?vue&type=template&id=4b313df4"
import script from "./Stop.vue?vue&type=script&lang=js"
export * from "./Stop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports